import { Component, OnDestroy, OnInit } from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { PostingService } from 'app/core/services/posting.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-denial-code',
  templateUrl: './denial-code.component.html',
  styleUrls: ['./denial-code.component.scss']
})
export class DenialCodeComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  denialCodeForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private postingService: PostingService,
    private sweetAlertHelper: SweetAlertHelper,
    private t2LoadingService: T2LoadingService,
  ) {
    this.initForm();
  }

  ngOnInit() {
    this.subscriptions.push(
      this.postingService.denialCode.subscribe((resp) => {
        if (resp && resp.type === 'setCode') {
          this.denialCodeForm.patchValue({denialcode : resp.code.toUpperCase()});
        }
      })
    );
  }

  initForm() {
    this.denialCodeForm = this.fb.group({
      denialcode: ['', Validators.required],
      description: ['', Validators.required]
    });

  }

  onSave() {
    this.t2LoadingService.show();
    this.postingService.registerDenialCode(this.denialCodeForm.value)
    .finally(() => {
      this.t2LoadingService.hiden();
      this.onCancelCode();
    })
    .subscribe((resp: any) => {
      if (resp.success) {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Success',
          text: resp.message,
          type: 'success',
        });
      }
    }, (error: any) => {
      this.sweetAlertHelper.captureException(error);
    });
  }

  onCancelCode() {
    this.postingService.closeModal.emit(true);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/denial-code/denial-code.component.ts